export class Search {
	static readonly type = '[condoCorporationSearch] search';
	constructor(public searchTerm: string) {}
}
